import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useChecklistMaquinaEquipListaFilter
 */

type State = {
  descricao: string | null;
  codigo: string | null;
  status: number;
};

export const initialChecklistMaquinaEquipLista: State = {
  descricao: null,
  codigo: null,
  status: 1,
};

export const useChecklistMaquinaEquipListaFilter = create<State>((set) => ({
  ...initialChecklistMaquinaEquipLista,
}));